import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import './BottomNavShell.css';
import './DeveloperBottomNav.css';
import { DSIcon } from '../design-system/primitives';

// Mirrors MachineBottomNav/MyAccountBottomNav: each tab is its own route/page
// component (DeveloperTools, DesignSystemReference, Devices, BadgeManagement,
// BoardGameLibrary),
// all admin-only tools formerly scattered across the sidebar - consolidated
// here so they share one nav instead of five separate sidebar entries.
// Square Integration is folded into the Integrations tab's content rather
// than being its own tab (it's one more admin integration, not a distinct
// workflow).
const TABS = [
  { path: '/developer', icon: <DSIcon name="plug" />, label: 'Integrations', match: (p) => p === '/developer' },
  { path: '/developer/design-system', icon: <DSIcon name="ruler" />, label: 'Design System', match: (p) => p === '/developer/design-system' },
  { path: '/developer/devices', icon: <DSIcon name="gamepad" />, label: 'Devices', match: (p) => p === '/developer/devices' },
  { path: '/developer/badges', icon: <DSIcon name="trophy" />, label: 'Badges', match: (p) => p === '/developer/badges' },
  { path: '/developer/board-games', icon: <DSIcon name="book" />, label: 'Board Games', match: (p) => p === '/developer/board-games' }
];

function DeveloperBottomNav() {
  const location = useLocation();
  const navigate = useNavigate();

  return (
    <nav className="bn-shell dbn-bottomnav">
      {TABS.map((tab) => {
        const isActive = tab.match(location.pathname);
        return (
          <button
            key={tab.label}
            type="button"
            className={`bn-shell-item dbn-bottomnav-item ${isActive ? 'active' : ''}`}
            onClick={() => navigate(tab.path)}
          >
            <span className="bn-shell-icon dbn-bottomnav-icon">{tab.icon}</span>
            <span className="dbn-bottomnav-label">{tab.label}</span>
          </button>
        );
      })}
    </nav>
  );
}

export default DeveloperBottomNav;
